import React from 'react'
import { Img } from 'styles/GlobalStyle'
import { RatingListStyles } from './Style'

const RatingList = (props) => {
    const { ratings, completeIndex = ratings.length } = props

    return (
        <RatingListStyles className='rating-list'>
            {ratings.map((rating, index) =>
                <div className='rating'>
                    <Img src={index < completeIndex ? rating.iconOn : rating.iconOff} />
                </div>
            )}
        </RatingListStyles>
    )
}

export default RatingList